import { render, staticRenderFns } from "./CostBearerElseEducationOtherCostsPreview.vue?vue&type=template&id=71aa3baa&scoped=true&"
import script from "./CostBearerElseEducationOtherCostsPreview.vue?vue&type=script&lang=ts&"
export * from "./CostBearerElseEducationOtherCostsPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aa3baa",
  null
  
)

export default component.exports